<template>
  <vs-row class="p-3 mt-2 shadow-sm bg-white email-row" @dblclick.native="viewEmail">
    <vs-col vs-lg="1" vs-type="flex" vs-align="center" vs-justify="center">
      <vs-avatar
        :icon="item.hasAttachments ? 'attach_file' : 'email'"
        :color="item.hasAttachments ? 'primary' : 'gray'"
        size="40px"
      />
    </vs-col>
    <vs-col vs-lg="7">
      <vs-row>
        <vs-col vs-lg="6">
          <div class="font-weight-bold text-truncate" :title="senderDisplay">
            <feather-icon icon="UserIcon" size="14" class="mr-1" />
            {{ senderDisplay }}
          </div>
        </vs-col>
        <vs-col vs-lg="6">
          <div class="text-muted text-truncate" :title="recipientDisplay">
            <feather-icon icon="ArrowRightIcon" size="14" class="mr-1" />
            {{ recipientDisplay }}
          </div>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col vs-lg="12">
          <div class="text-truncate mt-1" :title="item.subject">
            <strong>{{ item.subject }}</strong>
          </div>
        </vs-col>
      </vs-row>
      <vs-row v-if="item.hasAttachments && item.attachments.length > 0">
        <vs-col vs-lg="12">
          <div class="mt-1">
            <vs-chip
              v-for="attachment in visibleAttachments"
              :key="attachment.id"
              class="mr-1"
              color="rgba(var(--vs-primary), 0.1)"
            >
              <vs-avatar icon="attach_file" size="small" />
              {{ attachment.name }}
            </vs-chip>
            <span
              v-if="item.attachments.length > 3"
              class="text-muted small"
            >
              +{{ item.attachments.length - 3 }} más
            </span>
          </div>
        </vs-col>
      </vs-row>
    </vs-col>
    <vs-col vs-lg="2" vs-type="flex" vs-align="center">
      <div class="text-muted small">
        <feather-icon icon="ClockIcon" size="14" class="mr-1" />
        {{ localTimestamp | dateFormatDateTime }}
      </div>
    </vs-col>
    <vs-col vs-lg="2" vs-type="flex" vs-align="center" vs-justify="center">
      <b-button
        v-tooltip="'Ver correo'"
        variant="outline-primary"
        size="sm"
        class="btn-icon rounded-circle"
        @click.stop="viewEmail"
      >
        <feather-icon icon="EyeIcon" />
      </b-button>
    </vs-col>
  </vs-row>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ReceivedEmailsRow',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    localTimestamp() {
      if (!this.item.timestamp) return null;
      const ts = this.item.timestamp;
      return new Date(ts.endsWith('Z') ? ts : `${ts}Z`);
    },
    senderDisplay() {
      if (!this.item.from || this.item.from.length === 0) return 'Desconocido';
      return this.item.from[0];
    },
    recipientDisplay() {
      const recipients = this.item.to || this.item.tos || [];
      if (recipients.length === 0) return 'Sin destinatario';
      if (recipients.length === 1) return recipients[0];
      return `${recipients[0]} (+${recipients.length - 1})`;
    },
    visibleAttachments() {
      if (!this.item.attachments) return [];
      return this.item.attachments.slice(0, 3);
    }
  },
  methods: {
    ...mapActions('ReceivedEmails', ['viewEmailContent']),
    viewEmail() {
      this.viewEmailContent({ email: this.item });
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
      this.$bvToast.toast(
        `Se ha copiado: ${text}`,
        {
          title: '¡Copiado!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true
        }
      );
    }
  }
};
</script>

<style scoped>
.email-row {
  cursor: pointer;
  transition: background-color 0.2s;
}
.email-row:hover {
  background-color: #f8f9fa !important;
}
</style>
